/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Pattern_LuaInputs */

const vi_tea_purchase_pattern_lua = /** @type {(inputs: Tea_Purchase_Pattern_LuaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lứa`)
};

/**

* @param {Tea_Purchase_Pattern_LuaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_pattern_lua = /** @type {((inputs?: Tea_Purchase_Pattern_LuaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Pattern_LuaInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_pattern_lua(inputs)
});